import { CSSObject } from 'foundations-theming/utils';

/**
 * Get icon styles for IconButton context.
 * For IconButton, icons should always inherit the button's color
 * to match UIComponents behavior.
 */
export const getIconButtonIconStyles = (): CSSObject => {
  return {
    color: 'inherit',
  };
};
